import { useEffect, useState } from "react";
import DernieresReservation from "../Tableaux/10Reserv";
import NeutralTable from './../Tableaux/NeutralTable';

const StateContain = ({value, state, name, duration=400 })=>{


    const [animationClass, setAnimationClass] = useState('');
    const [currentNumber, setCurrentNumber] = useState(0);
    const [finalNumber, setFinalNumber] = useState(value.length);
    const [showTable, setShowTable] = useState(false);

    

    useEffect(() => {
        let start = 0;
        const increment = finalNumber / (duration / 100);

        const interval = setInterval(() => {

            start += increment;

            if (start >= finalNumber) {
                setCurrentNumber(finalNumber);
                clearInterval(interval);

            } else {
                setCurrentNumber(Math.floor(start));

            }

        }, 100);

        return () => clearInterval(interval); // Nettoyage lors du démontage du composant
    }, [finalNumber, duration]);


    return (

        <>
            {state === 'res' &&    
                <div 
                    className={`relative p-6 ${showTable ? 'bg-green-200' : 'bg-green-600'} shadow cursor-pointer rounded-2xl ${showTable ? 'w-full pb-10' : 'w-40'} duration-500 ease-in-out ${!showTable && 'hover:bg-green-800'}`} 
                    onClick={()=>{
                        setShowTable(!showTable)
                    }}
                >
                    <div className="space-y-2">
                        <div
                            className={`flex items-center space-x-2 text-sm font-medium ${showTable ? 'text-gray-800' :'text-gray-100'}`}>
                            <span>{name}</span>
                        </div>

                        <div className={`text-3xl ${showTable ? 'text-gray-800' :'text-gray-100'}`}>                        
                            {currentNumber}
                        </div>
                    </div>
                    
                    {showTable && <NeutralTable data={value} color={'green-800'}/>}
                </div>
            }

            {state === 'inWainting' &&    
                <div 
                    className={`relative p-6  ${showTable ? 'bg-indigo-200' : 'bg-indigo-600'} shadow cursor-pointer rounded-2xl ${showTable ? 'w-full' : 'w-40'} duration-500 ease-in-out ${!showTable && 'hover:bg-indigo-800'}`} 
                    onClick={()=>{
                        setShowTable(!showTable)
                    }}
                >                    
                    <div class="space-y-2">
                        <div
                            className={`flex items-center space-x-2 text-sm font-medium ${showTable ? 'text-gray-800' :'text-gray-100'}`}>
                            <span>{name}</span>
                        </div>

                        <div className={`text-3xl ${showTable ? 'text-gray-800' :'text-gray-100'}`}>                        
                            {currentNumber}
                        </div>
                    </div>

                    {showTable && <NeutralTable data={value} color={'indigo-800'}/>}

                </div>
            }


            {state === 'echec' &&    
                <div 
                    className={`relative p-6 ${showTable ? 'bg-red-200' : 'bg-red-600'} shadow cursor-pointer rounded-2xl ${showTable ? 'w-full' : 'w-40'} duration-500 ease-in-out ${!showTable && 'hover:bg-red-800'}`} 
                    onClick={()=>{
                        setShowTable(!showTable)
                    }}
                >                    
                    <div class="space-y-2">
                        <div
                            className={`flex items-center space-x-2 text-sm font-medium ${showTable ? 'text-gray-800' :'text-gray-100'}`}>
                            <span>{name}</span>
                        </div>

                        <div className={`text-3xl ${showTable ? 'text-gray-800' :'text-gray-100'}`}>                        
                            {currentNumber}
                        </div>
                    </div>

                    {showTable && <NeutralTable data={value} color={'red-600'}/>}

                </div>
            }



            {state === 'ended' &&    
                <div 
                    className={`relative p-6 ${showTable ? 'bg-gray-400' : 'bg-gray-800'} shadow cursor-pointer rounded-2xl ${showTable ? 'w-full' : 'w-40'}  duration-500 ease-in-out ${!showTable && 'hover:bg-gray-800'}`} 
                    onClick={()=>{
                        setShowTable(!showTable)
                    }}
                >                    
                    <div class="space-y-2">
                        <div
                            className={`flex items-center space-x-2 text-sm font-medium ${showTable ? 'text-gray-800' :'text-gray-100'}`}>
                            <span>{name}</span>
                        </div>

                        <div className={`text-3xl ${showTable ? 'text-gray-800' :'text-gray-100'}`}>                        
                            {currentNumber}
                        </div>
                    </div>

                    {showTable && <NeutralTable data={value} color={'gray-800'}/>}

                </div>
            }

        </>
    )
}

export default StateContain;